import moment from 'moment';
import { ContentTypeLabel } from '../common/enum/ContentTypeLabel';
import { Color, Position, Rotation } from '../components/AdjustWatermark';

export interface Watermark {
  name: string;
  text: string;
  position: Position;
  rotation: Rotation;
  color: Color;
}

export interface SubmittedWatermark {
  positions: string[];
  rotations: number[];
  colors: string[];
  actionDate: Date;
}

export function getWatermark(): Watermark[] | null {
  const watermark: string | null = localStorage.getItem('watermark');
  return watermark ? JSON.parse(watermark) : null;
}

export function submitWatermark(contentType: string): SubmittedWatermark {
  // Default watermark value
  let positions = ['Center', 'Center'];
  let rotations = [45, 45];
  let colors = ['#EB4034', '#EB4034'];

  const watermarks = getWatermark();
  // Replace with new watermark value
  if (watermarks) {
    positions = watermarks.map((watermark) => watermark.position.value);
    rotations = watermarks.map((watermark) => watermark.rotation.value);
    colors = watermarks.map((watermark) => watermark.color.value);
  }

  // Fix watermark position and rotation for Word and Excel
  if (contentType === ContentTypeLabel.word) {
    positions = ['Center', 'Center'];
    rotations = [45, 45];
  }
  if (contentType === ContentTypeLabel.excel) {
    positions = ['TopLeft', 'TopRight'];
    rotations = [0, 0];
  }

  return {
    positions,
    rotations,
    colors,
    actionDate: moment().toDate()
  };
}
